// extracted by mini-css-extract-plugin
export default {"protectedSpaceContainer":"protectedSpace_protectedSpaceContainer__GBXb+"};